import React, { useCallback, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Menu, MenuItem } from '@mui/material';
import { actions } from './Reports.redux';
import DeletePopover from 'components/DeletePopover';

const ContentBlocksCell = (params) => {
    const { field, row } = params;
    const id = row.string_id;
    const dispatch = useDispatch();
    const actionAnchor = useRef(null);
    const [actionsOpen, setActionsOpen] = useState(false);

    const beforeDeleteContentBlock = useCallback(() => {
        dispatch(actions.setState({ loading: true }));
    }, [dispatch]);

    const afterDeleteContentBlock = useCallback(() => {
        dispatch(actions.loadContentBlocks());
        setActionsOpen(false);
    }, [dispatch]);

    if (field !== 'actions') {
        return null;
    }

    return (
        <div onClick={(event) => event.stopPropagation()}>
            <Button
                variant="outlined"
                size="large"
                onClick={(event) => {
                    actionAnchor.current = event.currentTarget;
                    setActionsOpen(true);
                }}
            >
                ...
            </Button>
            <Menu open={actionsOpen} onClose={() => setActionsOpen(false)} anchorEl={actionAnchor.current}>
                <MenuItem>
                    <DeletePopover
                        objectType="CONTENT-BLOCK"
                        objectID={id}
                        afterDelete={afterDeleteContentBlock}
                        beforeDelete={beforeDeleteContentBlock}
                    >
                        <Button variant="text" size="large" color="error">
                            Delete Content Block
                        </Button>
                    </DeletePopover>
                </MenuItem>
            </Menu>
        </div>
    );
};

export default ContentBlocksCell;
